import Form from "./Component/Form";
import "./App.css";

const App = () => {
  return (
    <div className="App ">
      <Form />
    </div>
  );
};

export default App;
